import { render } from "./IconChevron.vue?vue&type=template&id=d6b554b2"
import script from "./IconChevron.vue?vue&type=script&lang=js"
export * from "./IconChevron.vue?vue&type=script&lang=js"
script.render = render

export default script